import { Page } from "@components"
import { Button } from "@heroui/react"
import { CircleStackIcon } from "@heroicons/react/24/outline";

const NoData = () => (
  <Page classNames="bg-content1">
    <div className="flex flex-col items-center justify-center min-h-screen -mt-16">
      <div className="flex flex-col items-center max-w-lg text-center">
        <CircleStackIcon className="w-auto h-auto max-h-96 text-foreground-800" />
        <h1 className="mb-2 text-3xl font-semibold text-foreground-700">No Data Found</h1>
        <p className="text-lg leading-7">No data found or incomplete data.</p> 
        <p className="mb-4 text-lg leading-7">Click below to connect to a data source.</p>
        <Button className="font-semibold" radius="full" size="lg" color="secondary" onPress={() => window.open("https://hub.schoolbooking.com/p/how-to-add-data-for-parent-meetings-n6lJEM", "_blank")}>
          Connect to a data source
        </Button>
      </div>
    </div>
  </Page>
)

export default NoData